import { CustomerType } from '../../types';
import { Skeleton } from './Skeleton';

type LabelSwitchProps = {
  activeCustomerType: CustomerType;
  loading?: boolean;
  onChange: (selectedCustomerType: CustomerType) => void;
};

export function LabelSwitch({
  activeCustomerType,
  loading,
  onChange,
}: LabelSwitchProps) {
  return (
    <div className="flex gap-1 self-center lg:self-stretch">
      {Object.values(CustomerType).map((customerType) => (
        <button
          className={`rounded-full px-4 py-3 text-white ${
            customerType === activeCustomerType ? 'bg-purple-100' : 'opacity-60'
          }`}
          disabled={loading}
          key={customerType}
          onClick={() => {
            onChange(customerType);
          }}
          type="button"
        >
          {loading ? <Skeleton className="h-6 w-20" /> : customerType}
        </button>
      ))}
    </div>
  );
}
